import { SettingsService } from 'services'
import { ThunkDispatchType } from 'types/redux'
import * as actions from './actions'
import { persistSettings } from './initialState'

const SETTINGS_PARAM = 'qirapagos-server.settings.*'

export const fetchSettings = () => async (dispatch: ThunkDispatchType) => {
  try {
    dispatch(actions.fetchSettingsPending())
    const response = await SettingsService.getSettings(SETTINGS_PARAM)
    if (response.data?.data) {
      persistSettings(response.data.data)
      dispatch(actions.fetchSettingsFulfilled(response.data.data))
    }
  } catch (error) {
    dispatch(actions.fetchSettingsRejected('Error fetching settings'))
  }
}
